import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const exporthistoryApi = createApi({
  reducerPath: "exporthistoryApi",
  baseQuery,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("userToken");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-Request-Id", crypto.randomUUID());
    return headers;
  },
  tagTypes: ["exporthistory"],
  endpoints: (builder) => ({
    getHistory: builder.query({
      query: ({ id}) =>
        `export/history/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item, index) => ({
          ...item,
          SrNo: index + 1,
          id: item.exportHistoryId, //  use backend's exportEntityId
        }));

      },
      providesTags: ["exporthistory"],
    }),
  }),
});

export const {
  useLazyGetHistoryQuery,
} = exporthistoryApi;
